import React from 'react';

import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

import ModularBlocks from 'components/ModularBlocks';

import { BlockGroupStartI } from 'interfaces/content-stack/modular-blocks/blockGroup';
import { ContentAlignmentType, FlexDirectionType, FlexWrapType, JustifyContentType } from 'interfaces/styles';

import blockGroupStartShape from 'shapes/components/blockGroupStartShape';

interface BlockGroupStyleProps {
  $alignContent?: ContentAlignmentType;
  $alignItems?: ContentAlignmentType;
  $flexDirection?: FlexDirectionType;
  $flexWrap?: FlexWrapType;
  $gap?: string;
  $justifyContent?: JustifyContentType;
  $useFlex?: boolean;
}

const BlockGroup = styled.div<BlockGroupStyleProps>`
  ${(props) => `
    align-content: ${props.$alignContent};
    align-items: ${props.$alignItems};
    display: ${props.$useFlex ? 'flex' : 'block'};
    flex-direction: ${props.$flexDirection};
    flex-wrap: ${props.$flexWrap};
    gap: ${props.$gap};
    justify-content: ${props.$justifyContent};

    @media (max-width: ${props.theme.breakpoints.md}) {
      ${ifProp(
        '$mobileTableStyles',
        css`
        display: flex;
        flex-direction: column;
        gap: 0px;git 
      `
      )}
    }

    > div {
      &:first-child {
        flex-basis: ${prop('$firstFlexBasis')};
      }

      &:nth-child(2) {
        flex-basis: ${prop('$secondFlexBasis')};
      }
    }
  `}
`;

const propTypes = {
  data: blockGroupStartShape,
};

export interface BlockGroupStartProps {
  data: BlockGroupStartI;
  page?: any;
}

function BlockGroupStart({ data, ...props }: BlockGroupStartProps) {
  const { childBlocks, flexboxOptions, useFlexbox } = data;
  const { alignContent, alignItems, flexDirection, flexWrap, gap, justifyContent } = flexboxOptions ?? {};

  return (
    <BlockGroup
      $alignContent={alignContent}
      $alignItems={alignItems}
      className='block-group'
      $flexDirection={flexDirection}
      $flexWrap={flexWrap}
      $gap={gap}
      $justifyContent={justifyContent}
      $useFlex={useFlexbox}
    >
      {childBlocks && <ModularBlocks modularBlocks={childBlocks} page={props?.page} />}
    </BlockGroup>
  );
}

BlockGroupStart.propTypes = propTypes;

export default BlockGroupStart;
